import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useBillingAuditLogs = () => {
  return useQuery({
    queryKey: ['billing-audit-logs'],
    queryFn: async () => {
      // Fetch billing automation logs
      const { data: automationLogs, error: automationError } = await supabase
        .from('billing_automation_logs')
        .select('*')
        .order('executed_at', { ascending: false })
        .limit(50);

      if (automationError) throw automationError;

      // Fetch email logs from audit_logs
      const { data: emailLogs, error: emailError } = await supabase
        .from('audit_logs')
        .select('*')
        .in('action', ['billing.email_sent', 'billing.email_failed', 'billing.invoice_create', 'billing.invoice_delete', 'billing.manual_payment'])
        .order('created_at', { ascending: false })
        .limit(100);

      if (emailError) throw emailError;

      return {
        automationLogs: automationLogs || [],
        emailLogs: emailLogs || [],
      };
    },
  });
};
